import { Uuid } from '@hidat/huijs-common';
import {
  SteeringPathInterface,
  SteeringPathsInterface,
  SteeringReason,
  SteeringReasons,
} from '@splixer/common';
import { Expose } from 'class-transformer';

export class SteeringPath implements SteeringPathInterface {
  @Expose()
  steeringReason: SteeringReasons = SteeringReason.RandomShow;
  @Expose()
  klass: string | undefined;
  @Expose()
  uid: Uuid | undefined;
  @Expose()
  name: string | undefined;
  @Expose()
  tagLine: string | undefined;
  @Expose()
  description: string | undefined;
  @Expose()
  hostName: string | undefined;
  @Expose()
  programId: number | undefined;
  @Expose()
  hostId: number | undefined;
  @Expose()
  linkUrl: string | undefined;
  @Expose()
  canPlay = true;
  @Expose()
  canQueue = true;
}

export class SteeringWheelPaths implements SteeringPathsInterface {
  @Expose()
  //straight: SteeringPath | undefined;
  @Expose()
  //left: SteeringPath | undefined;
  @Expose()
  //right: SteeringPath | undefined;
  @Expose()
  scheduled: SteeringPath[] | undefined;
  @Expose()
  related: SteeringPath[] | undefined;
  @Expose()
  random: SteeringPath[] | undefined;
  @Expose()
  detours: SteeringPath[] | undefined;
}
